<template>
    <div>
        <div id="stripe-payment-element" />
        <p v-if="errorMessage" style="color: #d32f2f; margin-top: 12px;">
            {{ errorMessage }}
        </p>
    </div>
</template>

<script>
import { buildStripeAppearance } from '@/utils/stripeAppearance.util';
import { loadStripe } from '@stripe/stripe-js';

export default {
    props: {
        clientSecret: {
            type: String,
            required: true,
        },
        sessionKey: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            stripe: null,
            elements: null,
            errorMessage: null,
        };
    },
    async mounted() {
        this.stripe = await loadStripe(this.sessionKey);
        if (!this.stripe) return;

        this.elements = this.stripe.elements({ clientSecret: this.clientSecret, appearance: buildStripeAppearance() });
        const paymentElement = this.elements.create('payment', { layout: { type: 'tabs' }, wallets: { link: 'never' } });

        paymentElement.mount('#stripe-payment-element');

        const parent = this.$el && this.$el.parentElement;

        if (parent) {
            parent.addEventListener('stripe-submit', this.handleSubmit);
        }
    },

    beforeDestroy() {
        this.$el.parentElement?.removeEventListener('stripe-submit', this.handleSubmit);
    },

    methods: {

        async handleSubmit() {
            if (!this.elements) return;

            this.errorMessage = null;

            try {
                const setupIntent = await this.confirmStripeSetup();

                let $form = jQuery(this.$el).closest('form');

                if (!$form.length) {
                    $form = jQuery('#orderForm');
                }
                $form.find('#setupIntentId').val(setupIntent.id);
                $form.find('#paymentToken').val(setupIntent.payment_method);

                if ($form.attr('id') === 'orderForm') {
                    $form.attr('action', Infusion.Url.getViewUrl('orderFormProcessing', 'updateOrderForm'));
                }
                // A billing-field change (e.g. zip/city/state) can trigger an async cart/tax
                // recalculation (submitFormUponChangeOnBilling -> ajaxSubmitForm) that resets
                // #proceedToCheckout to 'false' on completion. Since confirmStripeSetup() above
                // can take several seconds (SetupIntent confirmation + 3DS challenge), that stale
                // response can land and clobber the flag before this submit — re-assert it here
                // so the real checkout intent always wins.
                $form.find('#proceedToCheckout').val('true');
                $form.submit();
            } catch (e) {
                this.errorMessage = e && e.message
                    ? e.message
                    : 'An error occurred while confirming your payment method. Please try again.';
            }
        },

        async confirmStripeSetup() {
            const { error: submitError } = await this.elements.submit();

            if (submitError) throw new Error(submitError.message);

            const { setupIntent, error: confirmError } = await this.stripe.confirmSetup({
                elements: this.elements,
                redirect: 'if_required',
                confirmParams: { return_url: window.location.href },
            });

            if (confirmError) throw new Error(confirmError.message);

            return setupIntent;
        },
    },
};
</script>
